import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import StickyButton from '@/components/atom/buttons/StickyButton';
import FavoriteHeart from '@/components/atom/icon/FavoriteHeart';
import useCanProgressQnaWrite from '@/hooks/qna/mobile/write/useCanProgressQnaWrite';
import { QuestionCategoryType } from '@/hooks/qna/useQuestionDetailViewModel';
import theme from '@/styles/theme';
import { mobileLogger } from '@/utils/logger';

interface Props {
  pageName: string;
  buttonText: string;
  sectionName?: string;
  isPaymentFailed?: boolean;
  shouldShowEventText?: boolean;
  onClickRepay?: () => void;
  onClickButton?: () => void;
  questionCategory?: QuestionCategoryType;
}
/**
 *
 * @param pageName: string
 * @param buttonText: string
 * @param sectionName?: string
 *
 */

const QnaStickyWriteButton: FunctionComponent<Props> = ({
  pageName,
  buttonText,
  sectionName,
  shouldShowEventText,
  onClickButton,
  questionCategory,
}) => {
  const { clickProgressWrite } = useCanProgressQnaWrite();

  const onClickWriteButton = async () => {
    mobileLogger({
      logger: {
        eventName: 'write_question_sticky_click',
        pageName,
        payload: {
          sectionName: sectionName ?? 'question_list',
        },
      },
    });

    if (onClickButton) {
      onClickButton();
      return;
    }

    await clickProgressWrite();
  };

  const EventContent = () => {
    if (!shouldShowEventText || !questionCategory) {
      return null;
    }

    if (questionCategory.isRecommendedTreatment || questionCategory.categoryCode === 'POST_CONTRACEPTION') {
      return (
        <EventTextArea>
          <FavoriteHeart isActive={true} size={16} activeColor={theme.color.primary700} />
          <EventTextWrapper>
            <HighlightedEventText>1,839명</HighlightedEventText>
            <EventText>이 답변을 보고, 진료 받았어요!</EventText>
          </EventTextWrapper>
        </EventTextArea>
      );
    }

    return <></>;
  };

  return (
    <StickyButton>
      <StickyArea>
        <StickyButton.Button text={buttonText} onClick={onClickWriteButton} />
        <EventContent />
      </StickyArea>
    </StickyButton>
  );
};

export default QnaStickyWriteButton;

const StickyArea = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  div + div {
    margin: 0px;
  }
`;

const EventTextArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 8px;
  gap: 4px;
`;

const EventText = styled.span`
  ${({ theme }) => `
    ${theme.typography.UI15M};
    color: ${theme.color.gray500};
  `};
`;

const HighlightedEventText = styled.span`
  ${({ theme }) => `
    ${theme.typography.UI15SB};
    color: ${theme.color.primary700};
  `};
`;

const EventTextWrapper = styled.span``;
